import { ranking } from '@/mocks/motionComics';

const rankColors = ['text-accent-400', 'text-secondary-300', 'text-primary-300', 'text-foreground-300', 'text-foreground-300', 'text-foreground-300'];

export default function Ranking() {
  return (
    <section id="ranking" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-widest text-primary-400">TOP RANKING</span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-50 md:text-4xl">热门榜单 · 本周霸榜</h2>
            <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-300">
              根据播放量与追更热度综合排名，看看大家都在追哪部全彩动态漫画，跟着榜单准没错。
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
            <i className="ri-fire-fill text-secondary-600" aria-hidden="true"></i>每周五更新
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-3 md:gap-5">
          {ranking.map((item, i) => (
            <a
              key={item.rank}
              href={`#work-${item.title}`}
              className="card-lift flex items-center gap-4 rounded-lg border border-background-300/50 bg-background-100 p-3.5 md:p-4"
            >
              <span className={`font-heading text-3xl md:text-4xl ${rankColors[i]}`}>{item.rank}</span>
              <div className="h-16 w-12 overflow-hidden rounded-md md:h-20 md:w-14">
                <img
                  src={item.cover}
                  alt={`${item.title} 热门榜单封面`}
                  title={`${item.title} 热门动态漫画`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="truncate text-sm font-semibold text-foreground-50 md:text-base">{item.title}</h3>
                  <span className="whitespace-nowrap rounded bg-primary-500/15 px-1.5 py-0.5 text-[10px] text-primary-300">
                    {item.badge}
                  </span>
                </div>
                <p className="mt-1 text-xs text-foreground-400">{item.genre} · {item.hot} 热度</p>
                <div className="mt-2 h-1 w-full overflow-hidden rounded-full bg-background-300/60">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                    style={{ width: `${Math.max(38, 100 - i * 12)}%` }}
                  ></div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}